const firebaseConfig = {
  apiKey: "AIzaSyDRNBYwDeiLNkkXFXCVYAMAlPUl6az4oDg",
  authDomain: "tecno-mobile-skytech.firebaseapp.com",
  projectId: "tecno-mobile-skytech",
  storageBucket: "tecno-mobile-skytech.appspot.com",
  messagingSenderId: "835122685590",
  appId: "1:835122685590:web:37298371c4ea4ddf1f84b7"
};
  
  export default firebaseConfig;
